import React, { useState } from "react"
import * as layouts from "layouts"
import * as section from "."
import * as brandguide from "brandguide"
import { application as validations } from "brandguide/validations"
import * as md5x from "md5x"

export const Steps = {
	UPLOAD: 0,
	RESULT: 1,
}

export function Container(props: layouts.containers.ContainerProps): JSX.Element {
	const { ...rest } = props
	const cache = brandguide.cache.useCached()

	const _application = brandguide.api.zeros.guide.guideApplicationZero(cache.guide.guide?.application)

	const curstep = () => {
		switch (false) {
			case validations.valid.upload(_application):
				return Steps.UPLOAD
			default:
				return Steps.RESULT
		}
	}

	const [step, setStep] = useState(curstep)
	const [loading, setLoading] = useState(false)

	const handleOnStep = (step: number, data: brandguide.api.GuideApplication | undefined) => {
		if (!data) {
			setStep(step)
			return
		}

		const guide = { ...cache.guide.guide, application: data }
		const md5 = md5x.string(JSON.stringify(guide))

		if (md5 === cache.md5) {
			setStep(step)
			return
		}

		setLoading(true)
		cache.store({ ...cache, guide: { ...cache.guide, guide: guide } }).finally(() => {
			setStep(step)
			setLoading(false)
		})
	}

	return (
		<layouts.Flex overflowY="auto" {...rest}>
			<layouts.loading.screen flex="1" loading={loading}>
				{step === Steps.UPLOAD && <section.Uploads onChange={handleOnStep} />}
				{step === Steps.RESULT && <section.Result onChange={handleOnStep} />}
			</layouts.loading.screen>
		</layouts.Flex>
	)
}

Container.defaultProps = {
	flexDirection: "column",
	flex: "1",
	mb: "25px",
}

export default Container
